module.exports = __webpack_public_path__ + "static/charlies-house-08b7427641b132dcb87a8f527185ac9f.png";